import { OrderChat, OrderChatUnreadSummary, OrderChatUnreadSummaryItem } from "@core/types";
import { isLaterIso, maxIso } from "./timestamps";

type Cache = OrderChatUnreadSummary | undefined;

export const upsertSummaryItem = (prev: Cache, chat: OrderChat): OrderChatUnreadSummary => {
  const items = prev?.items ?? [];
  const idx = items.findIndex((it) => it.chatId === chat.id);

  if (idx === -1) {
    const newItem: OrderChatUnreadSummaryItem = {
      chatId: chat.id,
      orderId: chat.orderId,
      lastMessageAt: chat.lastMessageAt,
      customerLastReadAt: chat.customerLastReadAt,
      unreadCount: isLaterIso(chat.lastMessageAt, chat.customerLastReadAt) ? 1 : 0,
    };
    return { items: [...items, newItem] };
  }

  const existing = items[idx];
  const lastMessageAt = maxIso(existing.lastMessageAt, chat.lastMessageAt);
  const customerLastReadAt = maxIso(existing.customerLastReadAt, chat.customerLastReadAt);
  const unreadCount = isLaterIso(lastMessageAt, customerLastReadAt) ? existing.unreadCount : 0;

  return {
    items: items.map((it) =>
      it.chatId === chat.id
        ? { ...existing, orderId: existing.orderId || chat.orderId, lastMessageAt, customerLastReadAt, unreadCount }
        : it,
    ),
  };
};

export const removeSummaryItem = (prev: Cache, chatId: number): OrderChatUnreadSummary => ({
  items: (prev?.items ?? []).filter((it) => it.chatId !== chatId),
});

export const incrementSummaryItemUnread = (prev: Cache, chatId: number): Cache => {
  if (!prev || !prev.items.some((it) => it.chatId === chatId)) return prev;
  return {
    items: prev.items.map((it) =>
      it.chatId === chatId ? { ...it, unreadCount: it.unreadCount + 1 } : it,
    ),
  };
};
